import { createFileRoute, notFound } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Spinner } from '~/components/ui/spinner'

/**
 * The internal component gallery. Dev-only, on two independent levels:
 *
 *  1. `beforeLoad` throws `notFound()` outside dev, so a production build
 *     serves the root 404 for `/design-system` even if someone types it.
 *  2. Vite replaces `import.meta.env.DEV` with the literal `false` when
 *     building for production, which makes the ternary's dev branch — and
 *     the dynamic `import()` inside it — dead code the bundler drops. The
 *     gallery and its demo data never reach a production chunk.
 */
const DesignSystemPage = import.meta.env.DEV
  ? lazy(() =>
      import('~/components/design-system/design-system-page').then((module) => ({
        default: module.DesignSystemPage,
      }))
    )
  : () => null

export const Route = createFileRoute('/design-system')({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw notFound()
    }
  },
  component: RouteComponent,
  head: () => ({
    meta: [{ title: 'Design system — Planno' }, { content: 'noindex,nofollow', name: 'robots' }],
  }),
  ssr: false,
})

function RouteComponent() {
  return (
    <Suspense
      fallback={
        <div className="flex h-svh items-center justify-center bg-canvas">
          <Spinner />
        </div>
      }
    >
      <DesignSystemPage />
    </Suspense>
  )
}
